import { I as Icon, _ as __assign } from './loadable.esm-c9931684.js';
import React from 'react';
import 'styled-components';

var AlcoholIcon = function (props) { return (React.createElement(Icon, __assign({}, props, { viewBox: "0 0 46 46" }),
    React.createElement("path", { d: "M33.979 23.866L28 18.551V8H18v10.551l-5.979 5.315A9.01 9.01 0 009 30.593V45a1 1 0 001 1h26a1 1 0 001-1V30.593a9.01 9.01 0 00-3.021-6.727zm-6.272 13.427a.999.999 0 11-1.414 1.414L23 35.414l-3.293 3.293a.997.997 0 01-1.414 0 .999.999 0 010-1.414L21.586 34l-3.293-3.293a.999.999 0 111.414-1.414L23 32.586l3.293-3.293a.999.999 0 111.414 1.414L24.414 34l3.293 3.293zM28 6V1a1 1 0 00-1-1h-8a1 1 0 00-1 1v5h10z" }))); };

export default AlcoholIcon;
